import fetchBookings from './fetchBookings'
import fetchBookingsSearchFiltersOptions from './fetchBookingsSearchFiltersOptions'
import editBooking from './editBooking'
import fetchSingleBooking from './fetchSingleBooking'
import editKegCollectionRequest from './editKegCollectionRequest'
import fetchVenueCollectionInfo from './fetchVenueCollectionInfo'
import createKegCollectionRequest from './createKegCollectionRequest'
import deleteKegCollectionRequest from './deleteKegCollectionRequest'
import fetchVenues from './fetchVenues'
import fetchCollectors from './fetchCollectors'
import closeBooking from './closeBooking'

export default [
  ...fetchBookings,
  ...fetchBookingsSearchFiltersOptions,
  ...fetchSingleBooking,
  ...editBooking,
  ...createKegCollectionRequest,
  ...editKegCollectionRequest,
  ...deleteKegCollectionRequest,
  ...fetchVenues,
  ...fetchCollectors,
  ...fetchVenueCollectionInfo,
  ...closeBooking,
]
